/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AdDesignUpdatePathParams, AdDesignUpdateRequest, AdDesignUpdateResponse } from '../types/AdDesignUpdate'

/**
 * PATCH /organisations/:organisation/ad-designs/:adDesign
 * @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::update
 */
export async function adDesignUpdate(
	organisation: AdDesignUpdatePathParams['organisation'],
	adDesign: AdDesignUpdatePathParams['adDesign'],
	data: AdDesignUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AdDesignUpdateResponse>> {
	return axiosInstance.patch(`/organisations/${organisation}/ad-designs/${adDesign}`, data, config)
}
